import React from 'react';
import FormAssembly from "../FormAssembly/FormAssembly";

const contactUsForm = () => (
  <div className="contact-section__tab-content contact-section__tab-content--form-assembly">
    <h2 className="contact-us-form-title">Contact us</h2>
    <p className="contact-us-form-description">When you need to ship air cargo, there’s one Team you can count on to get the job done right. For general questions, or to request information, please use the form below and a Southwest Cargo representative will be ready to assist you. </p>
    <FormAssembly formReferenceName="CONTACT_FORM"/>
  </div>
);

export default contactUsForm;



// WEBPACK FOOTER //
// ./src/components/ContactUsForm/ContactUsForm.js